import { IonText } from '@ionic/react'
import numeral from 'numeral'

function formatCurrency(num: number, { abbreviate } = { abbreviate: false }) {
  if (!abbreviate) {
    // toFixed is decimal places
    return num
      ? '$' + num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      : '$0.00';
  }

  if (num >= 0 && num < 1000) return numeral(num).format('$0a')

  if (num >= 1000 && num < 10000) {
    return numeral(num).format('$0.0a')
  }

  if (num >= 10000 && num < 1000000) {
    return numeral(num).format('$0a')
  }

  return numeral(num).format('$0.0a')
}

function getNumber(value?: string | number | null) {
  if (typeof value === 'string') return +value
  if (typeof value === 'number') return value
  return 0
}

function Currency({
  value,
  abbreviate = false,
}: {
  value?: number | string | null
  abbreviate?: boolean
}) {
  const amount = getNumber(value)

  return (
    <IonText color={amount < 0 ? 'danger' : undefined}>
      {!isNaN(amount) ? formatCurrency(amount, { abbreviate }) : value}
    </IonText>
  )
}

export default Currency
